import { getElementSize } from '../utils/sizes';
import { ITEMS_BY_BREAKPOINTS } from './customer/default/totem.constants';

export * from './customer/default/totem.constants';

export const templates = {
  Totem: 'Totem',
};

const RATIO = 5 / 2;

const { sizes, imageOptions } = getElementSize(ITEMS_BY_BREAKPOINTS, RATIO, templates.Totem);
export { sizes, imageOptions };
